const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'graphical',
    key: 'graphical',
    title: '图形',
    width: 190,
    scopedSlots: {
      customRender: 'graphical'
    }
  },
  {
    dataIndex: 'publishDate',
    key: 'publishDate',
    title: '发布日期',
    width: 120
  },
  {
    dataIndex: 'statusText',
    key: 'statusText',
    title: '状态',
    width: 100,
    scopedSlots: {
      customRender: 'color'
    }
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 130,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = []

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [{ name: '删除', cb: 'singleDelete' }]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
